import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { SCENARIO_API_URL } from "../../../config";
import { PatchModelScenario } from "../types";

export interface IPatchScenarioMutation {
  scenario_id: string;
  data: PatchModelScenario;
}
export const useModelPatchScenario = () => {
  return useMutation({
    mutationFn: (props: IPatchScenarioMutation) =>
      axios
        .patch(
          `${SCENARIO_API_URL}/waves-scenario-manager-api/v1/scenarios/${props.scenario_id}`,
          props.data
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
